import { useFeatureFlag } from '@shared/feature-flags/useFeatureFlag'
import { DrawerSection, KeyValueGrid } from '@shared/design-system/ui'
import type { UserReceivingPlan } from '../model/user-receiving-plan'
import { planPercent } from '../model/user-receiving-plan'

export function PlanConditions({ plan }: { plan: UserReceivingPlan }) {
  const customFees = useFeatureFlag('customServiceFees')
  const terms = customFees ? plan.serviceFee : undefined
  const formula = `${planPercent(terms?.percentage ?? '9.9')} + US$ ${new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(terms?.fixedUsd ?? '1.49'))}`
  const national = plan.fees.find((fee) => fee.currency === 'BRL')!

  return (
    <>
      <DrawerSection
        title="Serviço VendePay"
        description={
          customFees
            ? 'Condição para novas vendas e novas assinaturas. Assinaturas existentes mantêm a taxa contratada. A parcela fixa em dólar é convertida em reais na cobrança.'
            : '9,9% + US$ 1,49 por cobrança, para qualquer venda. A parcela fixa é convertida em reais pela cotação registrada no momento da cobrança. Sem taxa de conversão.'
        }
      >
        <KeyValueGrid
          items={[
            {
              label: 'Taxa por cobrança',
              value: <span data-testid="receiving-plan-service-fee">{formula}</span>,
            },
          ]}
        />
      </DrawerSection>
      <DrawerSection
        title="Liberação do saldo"
        description="O prazo de liberação depende do meio de pagamento e do país de emissão do cartão, não da localização do comprador. Os prazos abaixo são referências; a previsão de cada cobrança vem da conta de pagamento. A data do depósito bancário pode variar. A reserva mantém sua própria data."
      >
        <KeyValueGrid
          items={[
            { label: 'Cartão nacional', value: 'D+30 (30 dias corridos)' },
            { label: 'Cartão internacional', value: 'D+5 (5 dias corridos)' },
            { label: 'Pix', value: '2 dias úteis' },
            { label: 'Boleto', value: '2 dias úteis' },
          ]}
        />
      </DrawerSection>
      <DrawerSection
        title="Reserva em reais"
        description={
          customFees
            ? 'A reserva do plano é aplicada em BRL, inclusive nas compras cobradas em outras moedas. Assinaturas existentes mantêm as taxas e a reserva contratadas em todas as renovações, mesmo após mudar de plano.'
            : 'A reserva do plano é aplicada em BRL, inclusive nas compras cobradas em outras moedas.'
        }
      >
        <KeyValueGrid
          items={[
            {
              label: 'Reserva',
              value: `${planPercent(national.nationalReservePercentage)} por ${national.nationalReserveDays} dias`,
            },
          ]}
        />
      </DrawerSection>
    </>
  )
}
